/**
 * 公共参数
 */
const title = [
  { title: "首页", id: 0, name: "" },
  { title: "解决方案", id: 1, name: "scheme" },
  { title: "关于我们", id: 2, name: "about" },
  { title: "新闻动态", id: 3, name: "news" },
  { title: "联系我们", id: 4, name: "contact" },
];

export { title };
